"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_1 = require("@framework/types");
const TemplateInput = props => {
    const { templateStatus = [types_1.TemplateStatus.ACTIVE, types_1.TemplateStatus.HIDDEN], contractFeatures } = props;
    const name = "templateIds";
    const form = (0, react_hook_form_1.useFormContext)();
    const tokenType = (0, react_hook_form_1.useWatch)({ name: "tokenType" });
    const merchantId = (0, react_hook_form_1.useWatch)({ name: "merchantId" });
    const contractIds = (0, react_hook_form_1.useWatch)({ name: "contractIds" });
    (0, react_1.useEffect)(() => {
        form.setValue(name, [], { shouldDirty: true, shouldTouch: true });
    }, [merchantId]);
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: name, controller: "templates", fetchData: {
            contractIds,
            templateStatus,
            contractFeatures,
            contractType: [tokenType],
            merchantId,
        }, multiple: true }));
};
exports.TemplateInput = TemplateInput;
//# sourceMappingURL=index.js.map